module.exports = __webpack_public_path__ + "img/caracteristicas-moviles-digi-2.375707dc.png";